const heroProductAdd = (hideSubscriptionOption = false) => ({
  drawerSide: '',
  stickyButtonVisible: false,
  hideSubscriptionOption,

  get selectedVariantsIds() {
    return this.selectedVariants.map((variant) => variant.id).join(',');
  },

  init() {
    this.setupStickyButton();

    this.parentSelectedVariants = this.selectedVariants;

    this.$watch('selectedVariantsIds', (val) => {
      this.parentSelectedVariants = this.selectedVariants;

      if (this.selectedVariants.length === 1) {
        const id = val;
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== id) {
          url.searchParams.set('variant', id);
          window.history.pushState({}, '', url.toString());
        }
      }
    });

    this.loadVariantFromUrl();
  },

  destroy() {
    this.intersectionObserver?.disconnect();
  },

  async handleButtonClick() {
    const { stateBase } = this;

    if (stateBase === 'available') {
      await this.addToCart();
      this.isWorking = false;
    }

    // TO DO: Add back in stock button handle
  },

  loadVariantFromUrl() {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');

    if (variantId) {
      const variant = this.product.variants.find((variant) => variant.id.toString() === variantId);

      if (variant) {
        Object.assign(
          this.selectedOptions,
          Object.fromEntries(variant.selectedOptions.map(({ name, value }) => [name, value])),
        );
        this.normalizeOptionsAndVariants(Object.entries(this.selectedOptions));
      }
    }
  },

  handlePopstate() {
    this.loadVariantFromUrl();
  },

  setupStickyButton() {
    this.intersectionObserver = new IntersectionObserver(([entry]) => {
      this.stickyButtonVisible = !entry.isIntersecting;
    }, {});

    this.intersectionObserver.observe(this.$refs.button);
  },
});

export default heroProductAdd;
